module.exports = __webpack_public_path__ + "img/monocycle-door.83463e78.jpg";